import { logErrorToConsole } from 'src/utils/util';

// Handler to toggle the next button in the calendar
export const toggleNextButton = (maxDate, monthDDRef, yearDDRef, monthNames) => {
    if (!maxDate) return;
    setTimeout(() => {
        try {
            if (!monthDDRef.current || !monthDDRef.current.input || !yearDDRef.current || !yearDDRef.current.input) return;
            var viewMonth = monthDDRef.current.input.innerText.split('\n')[0];
            var viewYear = yearDDRef.current.input.innerText.split('\n')[0];
            if (
                viewYear >= maxDate.getFullYear() &&
                monthNames.find((item) => item.name === viewMonth)?.id === maxDate.getMonth()
            ) {
                const { disableNextButton } = require('./disableNextButton');
                disableNextButton();
            }
        }
        catch (error) {
            logErrorToConsole(error);
        }
    }, 100);
};
